import {
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    EDIT_CASE_DETAILS_REQUEST,
    EDIT_CASE_DETAILS_SUCCESS,
    EDIT_CASE_DETAILS_FAILURE,
    CANCEL_CASE_REQUEST,
    CANCEL_CASE_SUCCESS,
    CANCEL_CASE_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_SUCCESS,
    GET_AVAILABLE_UNITS_FAILURE
} from './constants';

export function getCase(caseId) {
    return {
        type: GET_CASE_DETAILS_REQUEST,
        caseId: caseId
    }
}

export function getCaseSuccess(response) {
    return {
        type: GET_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function getCaseFailure() {
    return {
        type: GET_CASE_DETAILS_FAILURE,
        data: {}
    }
}

export function editCase(data) {
    return {
        type: EDIT_CASE_DETAILS_REQUEST,
        data: data
    }
}

export function editCaseSuccess(response) {
    return {
        type: EDIT_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function editCaseFailure() {
    return {
        type: EDIT_CASE_DETAILS_FAILURE,
        data: {}
    }
}


export function cancelCase(caseId) {
    return {
        type: CANCEL_CASE_REQUEST,
        data: {caseId}
    }
}

export function cancelCaseSuccess(response) {
    return {
        type: CANCEL_CASE_SUCCESS,
        data: response
    }
}

export function cancelCaseFailure() {
    return {
        type: CANCEL_CASE_FAILURE,
        data: {}
    }
}

export function getAvailableUnits(data) {
    return {
        type: GET_AVAILABLE_UNITS_REQUEST,
        data: data
    }
}

export function getAvailableUnitsSuccess(response) {
    return {
        type: GET_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function getAvailableUnitsFailure() {
    return {
        type: GET_AVAILABLE_UNITS_FAILURE,
        data: {}
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/CaseDetails/actions.js